module.exports = __webpack_public_path__ + "static/media/ckn_restaurante_categoria.b0dfa4f2.jpg";